import React, { useEffect } from "react"
import { Avatar, Grid, IconButton } from "@mui/material"
import { useHookstate, type State } from "@hookstate/core"
import FilterAutocompleteFetch from "~/components/FilterAutocompleteFetch"
import { useLang } from "~/hooks/useLang"
import {
  parseEquipmentDetail,
  // parseEquipmentDetail,
  type ItemCheckout, type RawEquipmentDetail
} from "../../../interface"
import FilterTextField from "~/components/FilterTextField"
import { Remove } from "@mui/icons-material"

interface EquipmentRowProps {
  readonly item: State<ItemCheckout>;
  readonly position: number;
  readonly disabledRemoveItem?: boolean;
  readonly warehouseId: State<number | null>;
  readonly onRemove: () => void;
}

export default function EquipmentRow({ item, disabledRemoveItem, position, warehouseId, onRemove }: EquipmentRowProps) {
  const { translate } = useLang();
  const rawEquipment = useHookstate<RawEquipmentDetail | null>(null)
  const rawEquipmentValue = rawEquipment.get()
  const rawEquipmentId = rawEquipment.get()?.id ?? null


  useEffect(() => {
    if (rawEquipmentValue) {
      const parsed = parseEquipmentDetail(rawEquipmentValue)
      item.merge({
        itemId: parsed.id,
        groupId: parsed.equipmentGroup.id,
        equipment: parsed,
        quantity: 1,
      })
    } else {
      item.merge({ itemId: null, groupId: null, equipment: null, quantity: null })
    }
  }, [rawEquipmentId])

  return (
    <>
      <Grid item xs={3}>
        <FilterAutocompleteFetch
          label={translate('Equipment')}
          urlFetch={'/equipment/all-for-logged-user'}
          dataRequest={'equipment'}
          paramsPayload={{ warehouse_id: warehouseId.get() }}
          size={'small'}
          disabled={!warehouseId.get()}
          onFetchChange={(id: number | null) => item.itemId.set(id)}
          getFullObject={rawEquipment}
          valueId={item.itemId.get() ?? undefined}
        />
      </Grid>
      <Grid item xs={3}>
        <FilterTextField
          label={translate('Equipment Group')}
          type="text"
          disabled
          currentText={item.equipment.get()?.equipmentGroup?.name ?? ''}
          onTextFieldChange={() => undefined}
        />
      </Grid>
      <Grid item xs={2}>
        <FilterTextField
          label={translate('Quantity')}
          type="number"
          disabled={true}
          currentText={item.quantity.get() !== null ? String(item.quantity.get()) : ''}
          onTextFieldChange={(val) => item.quantity.set(Number(val))}
        />
      </Grid>
      {(!disabledRemoveItem || position > 0) &&
        <Grid item xs={1}>
          <Avatar
            onClick={onRemove}
            sx={{
              width: 24,
              height: 24,
              cursor: 'pointer',
              backgroundColor: 'primary.main'
            }}
          >
            <Remove />
          </Avatar>
        </Grid>
      }
    </>

  )
}
